// management
export const SET_READY_STATE = 'SET_READY_STATE'

// management/logs_list
export const LIST_LOGS_STARTED = 'LIST_LOGS_STARTED'
export const LIST_LOGS_COMPLETED = 'LIST_LOGS_COMPLETED'
export const LIST_LOGS_FAILED = 'LIST_LOGS_FAILED'

// management/roles_list/create_role_form
export const CREATE_ROLE_STARTED = 'CREATE_ROLE_STARTED'
export const CREATE_ROLE_COMPLETED = 'CREATE_ROLE_COMPLETED'
export const CREATE_ROLE_FAILED = 'CREATE_ROLE_FAILED'

// management/roles_list
export const LIST_ROLES_STARTED = 'LIST_ROLES_STARTED'
export const LIST_ROLES_COMPLETED = 'LIST_ROLES_COMPLETED'
export const LIST_ROLES_FAILED = 'LIST_ROLES_FAILED'
export const DELETE_ROLE_STARTED = 'DELETE_ROLE_STARTED'
export const DELETE_ROLE_COMPLETED = 'DELETE_ROLE_COMPLETED'
export const DELETE_ROLE_FAILED = 'DELETE_ROLE_FAILED'

// management/permission_assignments_list
export const LIST_PERMISSION_ASSIGNMENTS_STARTED = 'LIST_PERMISSION_ASSIGNMENTS_STARTED'
export const LIST_PERMISSION_ASSIGNMENTS_COMPLETED = 'LIST_PERMISSION_ASSIGNMENTS_COMPLETED'
export const LIST_PERMISSION_ASSIGNMENTS_FAILED = 'LIST_PERMISSION_ASSIGNMENTS_FAILED'

// everywhere
export const CLEAR_STATES = 'CLEAR_STATES'
export const CLEAR_ACTION_STATES = 'CLEAR_ACTION_STATES'
